/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { sysAPI } from "../../apis/SysAPI";
import { DashboardTemplate } from "../../templates/DashboardTemplate"
import { Icon, Pagination, Container, Table, Loader, Segment, Dimmer, Popup } from 'semantic-ui-react'
//import { AddAdvisorModal } from '../../components/modal/AddAdvisorModal';
import { TabContainer } from '../../components/shared/TabContainer';
import moment, { prettyDate } from "../../helpers/moment-helpers";
import { useDispatch, useSelector } from "react-redux";
import MessageTablesEmpty from "../../components/globals/MessageTablesEmpty";
import { copyToClipboard } from "../../helpers";
import Filters from "./Filters";
import { setSnackbar } from "../../actions/snackbar.actions";

export const DashboardAdvisorsView = () => {
    const me = useSelector((state) => state.me);
    const dispatch = useDispatch();

    const pageSize = 15;
    const [filters, setFilters] = useState({
        mainCompanies: [],
        officeCompanies: [],
        excludeCompanies: [],
        searchInput: "",
        license: "",
        businessCategory: ""
    })
    const [advisorsList, setAdvisorsList] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [totalAdvisors, setTotalAdvisors] = useState(0);
    const [search, setSearch] = useState({activePage: 1, includeCompanies: '', excludeCompanies: '', searchInput: '', license: ''});
    const [counterSearched, setCounterSearched] = useState(-1)
    const [sort, setSort] = useState('');
    const [sortType, setSortType] = useState('ASC');
    const [sortChange, setSortChange] = useState(0);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [filterButtonIsDisabled, setFilterButtonIsDisabled] = useState(true)
    const [showTabActions, setShowTabActions] = useState(false);

    const apiCall = async (page=1) => {
        setIsLoading(true)
        setSearch({...search, activePage: page});
        try {
            if(filterButtonIsDisabled){
                // eslint-disable-next-line
                throw {message: "Not enough params"}
            }
            const response = await sysAPI.get(`/advisors`, {
                params:{
                    page,
                    size: pageSize,
                    query: filters.searchInput || undefined,
                    mainCompanies: filters.mainCompanies?.length ? filters.mainCompanies.join(",") : undefined,
                    officeCompanies: filters.officeCompanies?.length ? filters.officeCompanies.join(",") : undefined,
                    excludeCompanies: filters.excludeCompanies?.length ? filters.excludeCompanies.join(",") : undefined,
                    license: filters.license || undefined,
                    sort: sort,
                    sorttype: sortType,
                    businesscategory: filters.businessCategory || undefined,
                }
            })
            const { advisorsList, totalPages, total } = response.data;
            // console.log(totalPages);
            setAdvisorsList(advisorsList);
            setTotalPages(totalPages);
            setTotalAdvisors(total);
            setCounterSearched(counterSearched+1)
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Oops... something is wrong..."
            console.error(error);
            dispatch(setSnackbar({message, status: "error"}))
        }
        setIsLoading(false);
        setLoadingDownload(false);
    }

    const exportCall = async () => {
        setLoadingDownload(true);
        try {
            if(filterButtonIsDisabled){
                // eslint-disable-next-line
                throw {message: "Not enough params"}
            }
            const {data} = await sysAPI.get(`/advisors/export`,{
                params:{
                    query: filters.searchInput || undefined,
                    mainCompanies: filters.mainCompanies?.length ? filters.mainCompanies.join(",") : undefined,
                    officeCompanies: filters.officeCompanies?.length ? filters.officeCompanies.join(",") : undefined,
                    excludeCompanies: filters.excludeCompanies?.length ? filters.excludeCompanies.join(",") : undefined,
                    license: filters.license || undefined,
                    sort: sort,
                    sorttype: sortType,
                    businesscategory: filters.businessCategory || undefined,
                },
                responseType: "blob"
            })
            const href = URL.createObjectURL(data);
            const link = document.createElement("a");

            link.href = href;
            link.setAttribute('download', `Advisor List ${moment().format('MM-DD-YYYY hh.mm.ss')}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            //URL.removeObjectURL(href);
            dispatch(setSnackbar({message: "CSV downloaded"}))
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Oops... something is wrong..."
            console.error(error);
            dispatch(setSnackbar({message, status: "error"}))
        }
        setIsLoading(false);
        setLoadingDownload(false);
    }

    useEffect(() => {
        const hasPermissionsToShowActions = me?.permissions?.filter(p => ["advisors:copy_email", "advisors:copy_id"].includes(p)) || []
        if(hasPermissionsToShowActions.length > 0){
            setShowTabActions(true)
        }
    },[me])

    const pageChange = (e, { activePage }) => {
        apiCall(activePage)
    }

    const sortColumn = (column) => {
        if (column === sort) {
            setSortType(sortType === 'ASC' ? 'DESC' : 'ASC');
            setSortChange(sortChange + 1)
            return
        }

        setSort(column);
        setSortType('ASC');
        setSortChange(sortChange + 1)
    }

    useEffect(() => {
        sortChange > 0 && apiCall();
    }, [sortChange]);

    useEffect(() => {
        if(
            filters?.mainCompanies?.length ||
            filters?.excludeCompanies?.length ||
            filters?.license?.length ||
            filters?.businessCategory?.length ||
            filters?.searchInput?.length >= 3
        ){
            setFilterButtonIsDisabled(false)
        }else{
            setFilterButtonIsDisabled(true)
        }
    },[
        filters?.searchInput,
        filters?.mainCompanies,
        filters?.excludeCompanies,
        filters?.license,
        filters?.businessCategory,
    ])

    return (
        <DashboardTemplate scope='advisors' permission="advisors:advisor_view">
            <TabContainer
                title='Advisors Management'
                subtitle='CRUD of Advisors'
            >
                <div>
                    <Filters filterButtonIsDisabled={filterButtonIsDisabled} filters={filters} setFilters={setFilters} handlerSearch={apiCall} handlerDownload={exportCall} loading={isLoading} loadingDownload={loadingDownload} />
                </div>

                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Full Name</Table.HeaderCell>
                            <Table.HeaderCell style={{maxWidth: '200px'}}>Email</Table.HeaderCell>
                            <Table.HeaderCell
                                className={`table-header__order ${sort === 'company' ? 'active' : ''}`}
                                onClick={() => sortColumn('company')}
                                style={{minWidth: '115px'}}
                            >
                                Company
                                {(sort === 'company' && sortType === 'ASC') && <Icon name="sort up" />}
                                {(sort === 'company' && sortType === 'DESC') && <Icon name="sort down" />}
                                {sort !== 'company' && <Icon name="sort" />}
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                className={`table-header__order ${sort === 'poc' ? 'active' : ''}`}
                                onClick={() => sortColumn('poc')}
                            >
                                POC
                                {(sort === 'poc' && sortType === 'ASC') && <Icon name="sort up" />}
                                {(sort === 'poc' && sortType === 'DESC') && <Icon name="sort down" />}
                                {sort !== 'poc' && <Icon name="sort" />}
                            </Table.HeaderCell>
                            <Table.HeaderCell>Status</Table.HeaderCell>
                            <Table.HeaderCell>Business Category</Table.HeaderCell>
                            <Table.HeaderCell
                                textAlign="right"
                                className={`table-header__order ${sort === 'clients' ? 'active' : ''}`}
                                onClick={() => sortColumn('clients')}
                                style={{minWidth: '90px'}}
                            >
                                Clients
                                {(sort === 'clients' && sortType === 'ASC') && <Icon name="sort up" />}
                                {(sort === 'clients' && sortType === 'DESC') && <Icon name="sort down" />}
                                {sort !== 'clients' && <Icon name="sort" />}
                            </Table.HeaderCell>
                            <Table.HeaderCell>2FA</Table.HeaderCell>
                            <Table.HeaderCell
                                textAlign="right"
                                className={`table-header__order ${sort === 'expires' ? 'active' : ''}`}
                                onClick={() => sortColumn('expires')}
                            >
                                License Expires
                                {(sort === 'expires' && sortType === 'ASC') && <Icon name="sort up" />}
                                {(sort === 'expires' && sortType === 'DESC') && <Icon name="sort down" />}
                                {sort !== 'expires' && <Icon name="sort" />}
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                textAlign="right"
                                className={`table-header__order ${sort === 'renewal' ? 'active' : ''}`}
                                onClick={() => sortColumn('renewal')}
                            >
                                Renewal Date
                                {(sort === 'renewal' && sortType === 'ASC') && <Icon name="sort up" />}
                                {(sort === 'renewal' && sortType === 'DESC') && <Icon name="sort down" />}
                                {sort !== 'renewal' && <Icon name="sort" />}
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                textAlign="right"
                                className={`table-header__order ${sort === 'lastLogin' ? 'active' : ''}`}
                                onClick={() => sortColumn('lastLogin')}
                            >
                                Last Login
                                {(sort === 'lastLogin' && sortType === 'ASC') && <Icon name="sort up" />}
                                {(sort === 'lastLogin' && sortType === 'DESC') && <Icon name="sort down" />}
                                {sort !== 'lastLogin' && <Icon name="sort" />}
                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign="right"># Logins</Table.HeaderCell>
                            {showTabActions && <>
                                <Table.HeaderCell>Actions</Table.HeaderCell>
                            </>}
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {isLoading && <Table.Row>
                            <Table.Cell colSpan={13}>
                                <Segment style={{ width: '100%', height: '300px' }}>
                                    <Dimmer active inverted>
                                        <Loader inverted>Loading</Loader>
                                    </Dimmer>
                                </Segment>
                            </Table.Cell>
                        </Table.Row>}
                        {!isLoading && advisorsList?.map((advisor, index) => (
                            <TableBodyRow key={index} advisor={advisor} me={me} showTabActions={showTabActions} />
                        ))}
                    </Table.Body>
                </Table>
                {!isLoading && advisorsList.length < 1 &&  <MessageTablesEmpty counterSearched={counterSearched} />}
                <Container
                    fluid
                    textAlign='right'
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: '32px',
                    }}
                >
                    <div style={{ fontSize: '1.2em' }}>Total Advisors found: {totalAdvisors}</div>
                    <Pagination totalPages={totalPages} activePage={search.activePage} onPageChange={pageChange} />
                </Container>
            </TabContainer>
        </DashboardTemplate>
    )
}

const TableBodyRow = ({advisor, me, showTabActions}) => {
    const dateFormatting = (date, hour = true) => {
        return date && moment(date).isValid()
            ? hour
                ? moment(date).format('MM/DD/YYYY HH:mm:ss')
                : moment(date).format('MM/DD/YYYY')
            : 'N/A';
    }
    const [isCopied, setIsCopied] = useState(false)
    return (
        <Table.Row  style={{ color: advisor.hasActiveSession ? 'green' : 'black' }}>
            <Table.Cell>
                <Link style={{ color: advisor.hasActiveSession ? 'green' : 'black' }} to={`/dashboard/advisors/${advisor._id}`}>{advisor.fullName}</Link>
            </Table.Cell>
            <Table.Cell>{advisor.email}</Table.Cell>
            <Table.Cell>
                <Link style={{ color: advisor.hasActiveSession ? 'green' : 'black' }} to={`/dashboard/companies/${advisor.companyInfo?._id}`}>{advisor.companyInfo?.name}</Link>
            </Table.Cell>
            <Table.Cell>{advisor.companyInfo?.pocUser?.fullName}</Table.Cell>
            <Table.Cell>{advisor.status}</Table.Cell>
            <Table.Cell>{advisor.businessCategory}</Table.Cell>
            <Table.Cell textAlign="right">{advisor.totalClients}</Table.Cell>
            <Table.Cell positive={advisor.hasEnabled2FA}>{advisor.hasEnabled2FA ? 'Active' : 'Inactive'}</Table.Cell>
            <Table.Cell textAlign="right">{dateFormatting(advisor.licenseExpiresIn)}</Table.Cell>
            <Table.Cell textAlign="right">{dateFormatting(advisor.renewalDate, false)}</Table.Cell>
            <Table.Cell textAlign="right" style={{maxWidth: '100px'}}>{prettyDate({date: advisor.activity?.lastLogin || advisor.lastLogin, format: 'MM-DD-YYYY'})}</Table.Cell>
            <Table.Cell textAlign="right">{advisor.howManyLogins}</Table.Cell>
            {showTabActions && <>
                <Table.Cell>
                    {me?.permissions?.includes("advisors:copy_email") && <>
                        <Popup
                            on={['hover']}
                            trigger={
                                <Icon name='at' style={{cursor:"pointer"}} size="large" onClick={() => {
                                    copyToClipboard(`${advisor.email}`, false)
                                    setIsCopied(true)
                                    setTimeout(() => {
                                        setIsCopied(false)
                                    }, 1000)
                                }} />
                            }
                            content={isCopied ? 'Copied': 'Click to copy Email'}
                            inverted
                        />
                    </>}
                    {me?.permissions?.includes("advisors:copy_id") && <>
                        <Popup
                            on='hover'
                            trigger={
                                <Icon name='barcode' style={{cursor:"pointer"}} size="large" onClick={() => {
                                    copyToClipboard(`${advisor._id}`, false)
                                    setIsCopied(true)
                                    setTimeout(() => {
                                        setIsCopied(false)
                                    }, 1000)
                                }} />
                            }
                            content={isCopied ? 'Copied': 'Click to copy ID'}
                            inverted
                        />
                    </>}
                </Table.Cell>
            </>}
        </Table.Row>
    )
}